import { atom, createStore } from 'jotai';

export const store = createStore();
export const loginAtom = atom({});

